import React from 'react';
import { Collapse } from 'react-bootstrap';
import { useHandleAccordion } from './hooks/useHandleAccordion';
import { ChevronUp, ChevronDown } from 'react-bootstrap-icons';
import './accordion.scss';

export default function Accordion({
  title,
  children,
  defaultOpen = false,
  className = '',
  triggerClassName = '',
  additionalComponent = null
}) {
  const { isOpen, handleToggle } = useHandleAccordion({ defaultOpen });
  return (
    <div className={`container ${className}`}>
      <button
        className={`accordion_button d-flex align-items-center justify-content-between w-100 ${triggerClassName}`}
        onClick={handleToggle}
      >
        <div className="mb-0 largeFont font-weight-bold">{title}</div>
        <div className="d-flex align-items-center">
          {additionalComponent}
          {isOpen ? (
            <ChevronUp fontWeight="bold" className="mb-0 largeFont font-weight-bold ml-2" />
          ) : (
            <ChevronDown className="mb-0 largeFont font-weight-bold ml-2" />
          )}
        </div>
      </button>
      <Collapse in={isOpen}><div>{children}</div></Collapse>
    </div>
  );
}
